import { render, staticRenderFns } from "./DeleteBox.vue?vue&type=template&id=09b08846&scoped=true&"
import script from "./DeleteBox.vue?vue&type=script&lang=js&"
export * from "./DeleteBox.vue?vue&type=script&lang=js&"
import style0 from "./DeleteBox.vue?vue&type=style&index=0&id=09b08846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b08846",
  null
  
)

export default component.exports